module.exports = __webpack_public_path__ + "img/sw1-b1.6c8ef2d2.jpg";